import { Trans, useLingui } from "@lingui/react/macro";

import { findingLabel } from "../../model/FINDING_LABELS";
import type { DashboardFindingStat } from "../../model/TeamDashboard";
import { BarList } from "./BarList";
import { DashboardCard } from "./DashboardCard";

type FindingsProps = {
  findings: DashboardFindingStat[];
  analyzedPlayers: number;
};

// «Что находим в разборах»: у скольких игроков находка была хоть в одном готовом разборе
// периода, по убыванию. Подсказывает, какие детекторы и тренировки важнее.
export const Findings = ({ findings, analyzedPlayers }: FindingsProps) => {
  const { i18n } = useLingui();
  const number = new Intl.NumberFormat(i18n.locale);
  const analyzed = number.format(analyzedPlayers);
  const rows = findings.map((row) => {
    const label = findingLabel(row.code);
    return {
      key: row.code,
      label: typeof label === "string" ? label : i18n._(label),
      value: row.players,
    };
  });

  return (
    <DashboardCard
      title={<Trans>What analyses find</Trans>}
      description={<Trans>How many players had the finding in at least one analysis</Trans>}
    >
      {rows.length === 0 ? (
        <p className="text-[13px] text-muted">
          <Trans>No finished analyses in this period.</Trans>
        </p>
      ) : (
        <BarList rows={rows} labelWidth="wide" data-list="findings" />
      )}
      <p className="border-t border-border/60 pt-2.5 text-[13px] text-muted">
        <Trans>
          Out of <strong className="text-foreground">{analyzed}</strong> players with finished
          analyses in the period.
        </Trans>
      </p>
    </DashboardCard>
  );
};
